import { useState } from 'react'

import clsx from 'clsx'
import IAccordionTypes from './Accordion.types'

const Accordion = (props: IAccordionTypes['IAccordionProps']) => {
  // Hooks and vars
  const [isOpen, setIsOpen] = useState(props?.initialState ?? true)

  const { header, children } = props

  // Functions

  const toggleAccordion = () => {
    setIsOpen(!isOpen)

    if (isOpen) props?.onOpen?.()
    else props?.onClose?.()
  }

  return (
    <div
      id={props?.id}
      className={clsx('border rounded-md shadow-sm border-[#D3DAEE]', props.className)}
    >
      <div
        className={clsx(
          'flex justify-between items-center px-4 py-3',
          props.headerWrapperClassName,
          !props.disabled && 'cursor-pointer'
        )}
        onClick={() => !props.disabled && toggleAccordion()}
      >
        <div
          //! This is the header text container
          className={clsx(
            'text-base flex-1 ',
            props.headerTextClassName,
            isOpen && 'text-SeabiscuitMainThemeColor accOpen font-bold'
          )}
        >
          {header}
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {props?.status && (
            <div
              className={clsx(
                'text-[14px] text-center rounded-full py-0.5 px-2 min-w-[90px]',
                props?.status === 'Available'
                  ? 'bg-SeabiscuitGreenThemeColor/5 text-SeabiscuitGreenThemeColor'
                  : 'bg-SeabiscuitGrayThemeColor text-SeabiscuitDark200ThemeColor',
                isOpen && '!bg-[#fff4f6] text-SeabiscuitMainThemeColor'
              )}
            >
              {props.status}
            </div>
          )}
          {props.info && (
            <span
              className={clsx(
                'text-[14px]',
                isOpen ? 'text-SeabiscuitMainThemeColor' : 'text-SeabiscuitDark200ThemeColor'
              )}
            >
              {props.info}
            </span>
          )}
          {!props.disabled && (
            <>
              {' '}
              {isOpen ? (
                <div className={'add_icon cursor-pointer'}>
                  <img src={'/assets/og_icons/CloseArrow.svg'} alt="Close" />
                </div>
              ) : (
                <div className={'remove_icon cursor-pointer'}>
                  <img src={'/assets/og_icons/OpenArrow.svg'} alt="Open" />
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div
        className={clsx(
          `px-3 transition-all duration-300 ease-in-out`,
          isOpen ? 'h-fit opacity-100 pb-3' : 'h-0 opacity-0 overflow-hidden',
          props?.childrenContainerClassName
        )}
      >
        {children}
      </div>
      {props.footer && <div className={'px-3 pb-3 '}>{props.footer}</div>}
    </div>
  )
}

export default Accordion
